import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ps-panel" }
const _hoisted_2 = { class: "ps-panel-hd" }
const _hoisted_3 = { class: "ps-field-group" }
const _hoisted_4 = { class: "input-field" }
const _hoisted_5 = { for: "ps-name" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "input-field" }
const _hoisted_8 = { for: "ps-username" }
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  key: 0,
  class: "ps-error"
}
const _hoisted_11 = { class: "ps-panel-ft" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('profile.editProfile')), 1),
      _cache[4] || (_cache[4] = _createElementVNode("p", null, "Nome de exibição e nome de usuário para acesso.", -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('profile.displayName')), 1),
        _createElementVNode("input", {
          id: "ps-name",
          value: _ctx.name,
          type: "text",
          onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:name', ($event.target as HTMLInputElement).value)))
        }, null, 40, _hoisted_6)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('profile.usernameLabel')), 1),
        _createElementVNode("input", {
          id: "ps-username",
          value: _ctx.username,
          type: "text",
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:username', ($event.target as HTMLInputElement).value)))
        }, null, 40, _hoisted_9)
      ])
    ]),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        class: "btn btn-primary btn-login",
        type: "button",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('save')))
      }, _toDisplayString(_ctx.$t('common.save')), 1),
      _createElementVNode("button", {
        class: "btn btn-ghost btn-login",
        type: "button",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('cancel')))
      }, _toDisplayString(_ctx.$t('common.cancel')), 1)
    ])
  ]))
}